import packageInfo from '../../../package.json';

export interface AppVersionInfo {
  version: string;
  build: string;
  tag: string;
}

const version = (packageInfo as { version?: string }).version || '0.1.0';
const build = (packageInfo as { build?: string }).build || '0';

export const APP_VERSION = version;
export const APP_BUILD = build;
export const APP_VERSION_TAG = `${version}_${build}`;
export const APP_VERSION_LABEL = `v${version}_${build}`;
